import { Container, Stack } from "@chakra-ui/react";
import React from "react";
import { CONTAINER_W, MODAL_W } from "../constants";

type PropTypes = {
  type: "modal" | "page";
  children: React.ReactNode;
};

const BasicPage = ({ type, children }: PropTypes) => {
  return (
    <Container maxW={type === "modal" ? MODAL_W : CONTAINER_W}>
      <Stack
        spacing={6}
        textAlign="center"
        px={{ base: 4, sm: 12 }}
        py={10}
        background="white"
        boxShadow="lg"
        borderRadius="xl"
      >
        {children}
      </Stack>
    </Container>
  );
};

export default BasicPage;
